import { render, staticRenderFns } from "./ElementAddFromLibraryDialog.vue?vue&type=template&id=0fae3646"
import script from "./ElementAddFromLibraryDialog.vue?vue&type=script&lang=js"
export * from "./ElementAddFromLibraryDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports